// Entry point for the build script in your package.json

import Rails from "@rails/ujs"
import * as bootstrap from "bootstrap"

Rails.start()
